import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyNationalGuard({}) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={"Wyoming Air National Guard"}
      subtitle={
        "Local Telecommunication Services (LTS) Conversion – LSTDM to SIP Trunking"
      }
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Background</NtCaseStudyTextBold>
        {"\n\n"} The Wyoming Air National Guard required a modern, secure, and
        scalable telecommunications upgrade to transition from legacy LSTDM
        infrastructure to SIP trunking technology. This upgrade was critical to
        improve communication efficiency, ensure compliance with federal
        requirements, and support both inbound and outbound calling capabilities
        across their network.{"\n\n"}{" "}
        <NtCaseStudyTextBold>Challenges</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Maintaining uninterrupted service during the transition, with a seamless
        porting and cutover process scheduled outside of business hours.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Integrating new SIP trunking with existing legacy systems via TDM
        emulation to support the Avaya PBX system using PRI handoff rather than
        native SIP.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Supporting Direct Inward Dialing (DID) numbers as specified.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Ensuring compliance with emergency calling requirements, including
        Kari’s Law and dynamic E911 routing.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Handling Government operations post-TDM emulation point while NT Connect
        managed the SIP trunking infrastructure.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Solution</NtCaseStudyTextBold>
        {"\n\n"} NT Connect Holdings, Inc. designed and implemented a robust,
        secure, and scalable SIP trunking solution tailored to the Wyoming Air
        National Guard’s specific operational and technical needs. Key elements
        included:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Seamless Porting & Transition:
        </NtCaseStudyTextBold>{" "}
        Comprehensive planning and execution ensured zero downtime and
        uninterrupted telecommunication services during cutover.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>TDM Emulation:</NtCaseStudyTextBold> Full
        compatibility was achieved with the existing Avaya CM7 telephony
        environment, allowing continued use of PRI handoff.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Scalability & Security:</NtCaseStudyTextBold> The
        SIP trunking solution was designed for growth and included redundancy to
        maximize uptime and safeguard communications.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>E911 Compliance:</NtCaseStudyTextBold> The The
        system met all federal emergency communication requirements, including
        Kari’s Law and dynamic call routing for enhanced safety and
        responsiveness.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Dedicated Support: </NtCaseStudyTextBold> TNT
        Connect’s expert team provided ongoing technical support and ensured
        adherence to the project schedule and quality benchmarks.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Results</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Successful migration of all DIDs to a modern SIP trunking system with
        zero service interruptions.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Full integration with existing telephony infrastructure, preserving
        investments in legacy systems while leveraging new technology.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Enhanced communication reliability and security aligned with federal
        standards.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Positive feedback from the Wyoming Air National Guard on the smooth
        transition and ongoing operational support.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Conclusion</NtCaseStudyTextBold>
        {"\n\n"}NT Connect Holdings, Inc. demonstrated its expertise in
        delivering mission-critical telecommunications upgrades through this
        successful project with the Wyoming Air National Guard. By combining
        advanced SIP trunking technology with strategic implementation, NT
        Connect ensured the Guard’s communication infrastructure is
        future-ready, secure, and fully compliant, empowering them to meet
        mission demands efficiently and reliably.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyNationalGuard;
